import { useFeatureFlagStore } from '@moniebook-web/store';
import { itemService } from '../../services';
import {
    BACKGROUND_SYNC_STATUS,
    useBackgroundItemSyncStore,
} from '../../store';
import { FEATURE_FLAGS } from '../../types';

export async function runBackgroundItemSync() {
    const { featureFlags } = useFeatureFlagStore.getState();
    if (!featureFlags?.[FEATURE_FLAGS.ENABLE_PROGRESSIVE_INVENTORY_SYNC]) {
        return;
    }

    const { itemsNextPage, syncStatus } = useBackgroundItemSyncStore.getState();
    if (
        itemsNextPage === null ||
        syncStatus === BACKGROUND_SYNC_STATUS.Syncing
    ) {
        return;
    }

    useBackgroundItemSyncStore
        .getState()
        .setSyncStatus(BACKGROUND_SYNC_STATUS.Syncing);

    try {
        await itemService.fetchAndBulkUpsert(
            undefined,
            (_, nextPage) => {
                if (!nextPage) {
                    return;
                }
                useBackgroundItemSyncStore
                    .getState()
                    .setItemsNextPage(nextPage);
            },
            undefined,
            undefined,
            itemsNextPage,
        );
        useBackgroundItemSyncStore.getState().clearItemsNextPage();
        useBackgroundItemSyncStore
            .getState()
            .setSyncStatus(BACKGROUND_SYNC_STATUS.Success);
    } catch {
        useBackgroundItemSyncStore
            .getState()
            .setSyncStatus(BACKGROUND_SYNC_STATUS.Failed);
    }
}
